import { useState, useEffect } from "react";
import { Staff } from "../types/order";
import api from "../../../../../features/auth/axiosConfig";

export const useStaff = () => {
  const [staffList, setStaffList] = useState<Staff[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getStaffList = async () => {
    try {
      setLoading(true);
      const response = await api.get("/app/v1/pos/staff?is_deleted=false");
      setStaffList(response.data.result || []);
    } catch (error) {
      console.error("API Error:", error);
      setError("Failed to fetch staff list");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStaffList();
  }, []);

  return { staffList, loading, error, refetch: getStaffList };
};
